function devicesReducer(state: any, { type, payload }: any) {
  switch (type) {
    case "UPDATE_DEVICES":
      return { ...state, ...payload };
    default:
      return state;
  }
}

export default devicesReducer;
